import React, { useState, useRef } from 'react'

import { Scrollbars } from 'react-custom-scrollbars'
import classNames from 'classnames'
import ChipDropdownItem from './ChipDropdownItem'
import ChipDropdownLabel from './ChipDropdownLabel'
import DropdownContainer from '../DropdownContainer'
import Accordion from 'components/Accordion/Accordion'
import { hexToRgba } from '../../utils/common'
import { SearchIcon, CloseIcon } from 'images/common'
import './style.scss'

const ChipDropdown = ({
  onItemClick, color, background, list = [], chevronOnly, label, labelOnly, value, selected, hexColor, labelCapitalize, onClick, customIcon, isActionMenu, autoHeightMax = 178, customIcons, onSearch, isSearchable, accordionMenu = [], theme
}) => {
  const [showMenu, setShowMenu] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const searchInputRef = useRef(null)

  const labelClass = classNames(
    'viso-chip-dropdown__label viso-text-white',
    labelOnly && 'viso-chip-dropdown__label--label-only',
    background && `viso-chip-dropdown__label--bg-${background}`,
    color && `viso-chip-dropdown__label--${color}`
  )

  const handleSearch = (value) => {
    setSearchValue(value)
    onSearch && onSearch(value)
  }

  const onShowMenu = () => {
    onClick && onClick()
    if (list) {
      setShowMenu(true)

      if (isSearchable && searchInputRef.current) {
        searchInputRef.current.focus()
      }
    }
  }

  return (
    <div className='viso-chip-dropdown' onMouseLeave={() => setShowMenu(false)}>
      <div
        className={labelClass}
        onClick={onShowMenu}
        style={{
          background: hexColor,
          borderColor: hexColor,
          boxShadow: `0px 5px 15px 0px ${hexToRgba(hexColor, 0.43)}`
        }}
      >
        <ChipDropdownLabel color={color} chevronOnly={chevronOnly} label={label} selected={selected} labelCapitalize={labelCapitalize} hexColor={hexColor} background={background} labelOnly={labelOnly} customIcon={customIcon} />
      </div>
      {isActionMenu ?
        <DropdownContainer
          actions={list}
          listClick={onItemClick}
          showDropdown={showMenu}
          setShowDropdown={setShowMenu}
          autoHeightMax={autoHeightMax}
        />
        :
        <div className={classNames(
          'viso-chip-dropdown__menu select__dropdown_container3',
          showMenu && 'viso-chip-dropdown__menu--visible',
          customIcons && 'viso-chip-dropdown__menu--icons',
          isSearchable && 'viso-chip-dropdown__menu--search'
        )}>
          {isSearchable &&
            <div
              className={classNames(
                'text-field text-field_nolabel text-field--search',
                (list.length > 0 || accordionMenu.length > 0) && 'text-field--padding'
              )}
            >
              <input
                type="text"
                placeholder="Search"
                className={classNames(
                  'text-field__input text-field__input--search',
                  list.length === 0 && 'viso-border-none'
                )}
                ref={searchInputRef}
                onChange={(e) => handleSearch(e.target.value)}
                value={searchValue}
              />
              <div className="text-field__icon">{!searchValue && <SearchIcon />}</div>
              {searchValue &&
                <span className="cursor text-field__icon text-field__icon_clickable" onClick={() => handleSearch('')}>
                  <CloseIcon />
                </span>
              }
            </div>
          }
          {accordionMenu.length > 0 ?
            <Accordion
              items={accordionMenu.map(accordion => ({
                title: accordion.title,
                contentRenderer: () =>
                  <div>
                    {accordion.list.map((option, index) => (
                      <ChipDropdownItem
                        key={`${index}_${option.value}`}
                        row={option}
                        setShowMenu={setShowMenu}
                        onOutsideClick={() => setShowMenu(false)}
                        onItemClick={onItemClick}
                        disabled={option.value === value}
                        isSearchable={isSearchable}
                      />
                    ))}
                  </div>
              }))}
              color={theme}
              fixedHeight={100}
              defaultOpenIndex={0}
              alwaysOpen={true}
            />
            :
            <Scrollbars
              autoHeight
              autoHide
              autoHideDuration={1}
              className='custom-scrollbars'
              autoHeightMax={autoHeightMax}
              universal
            >
              <div className='viso-chip-dropdown__items select__dropdown'>
                {list
                  .map((row) => {
                    return (
                      <ChipDropdownItem
                        key={row.value}
                        row={row}
                        setShowMenu={setShowMenu}
                        onOutsideClick={() => setShowMenu(false)}
                        onItemClick={onItemClick}
                        disabled={row.value === value}
                        labelCapitalize={labelCapitalize}
                        isSearchable={isSearchable}
                      />
                    )
                  })
                }
              </div>
            </Scrollbars>
          }
        </div>
      }
    </div>
  )
}

export default ChipDropdown